import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { KeyRound } from 'lucide-react';
import { Layout } from '@/components/layout/Layout';
import { ApiKeysManager } from '@/components/api-keys/ApiKeysManager';

/**
 * Chaves de API — /api-keys
 *
 * A página é só a casca. Todo o estado (incluindo o dos modais) vive no
 * ApiKeysManager, porque o Layout renderiza os filhos duas vezes.
 */
export default function ApiKeys() {
  useLanguage();
  return (
    <Layout fixedSidebar>
      <div className="flex-1 flex flex-col overflow-hidden">
        <div className="flex-shrink-0 bg-transparent">
          <div className="max-w-[1600px] w-full mx-auto px-4 md:px-8 pt-4 md:pt-4 pb-4 md:pb-5">
            <div className="flex items-center gap-2.5">
              <KeyRound className="h-[18px] w-[18px] text-[#2D6CF6]" strokeWidth={2} />
              <h1 className="text-[20px] md:text-[22px] font-semibold text-[#1E2330] tracking-tight leading-[1.2]">
                {translateInterfaceText("Chaves de API")}</h1>
            </div>
          </div>
          <div
            className="hidden lg:block h-px w-full"
            style={{ backgroundColor: 'rgba(0, 0, 0, 0.08)' }}
          />
        </div>

        <main className="flex-1 overflow-y-auto">
          <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8 py-6">
            <ApiKeysManager />
          </div>
        </main>
      </div>
    </Layout>
  );
}
